export default {
  SET_RPC: "SET_RPC",
  SET_AUTH_TOKEN: "SET_AUTH_TOKEN",
  SET_AUTH_ERROR: "SET_AUTH_ERROR",
  SET_USER_DETAILS: "SET_USER_DETAILS",
  SET_LOGIN_RESPONSE: "SET_LOGIN_RESPONSE",
  SET_PASSWORD_OTP: "SET_PASSWORD_OTP",
  SET_USER_STATUS: "SET_USER_STATUS",
  SET_REGISTER_OTP_SENT: "SET_REGISTER_OTP_SENT",
  SET_RESEND_OTP: "SET_RESEND_OTP",
  SET_RESET_PASSWORD_SUCCESS: "SET_RESET_PASSWORD_SUCCESS",
  SET_LOGIN_OTP: "SET_LOGIN_OTP",
  SET_LOGIN_LOADER: "SET_LOGIN_LOADER",
  RESET_AUTH_STATE: "RESET_AUTH_STATE",
  SET_ACCOUNT_DETAILS: "SET_ACCOUNT_DETAILS",
  CLOSE_MNEMONICS_POPUP: "CLOSE_MNEMONICS_POPUP",
  OPEN_MNEMONICS_POPUP: "OPEN_MNEMONICS_POPUP",
  SET_WALLET_DETAILS: "SET_WALLET_DETAILS",
  SET_LIMITS: "SET_LIMITS"
};